var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"check-box"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkedState},on:{"click":_vm.onCheckBoxClick}}),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }